import { render, staticRenderFns } from "./GameLabelList.vue?vue&type=template&id=bc7d835c&scoped=true"
import script from "./GameLabelList.vue?vue&type=script&lang=js"
export * from "./GameLabelList.vue?vue&type=script&lang=js"
import style0 from "./GameLabelList.vue?vue&type=style&index=0&id=bc7d835c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7d835c",
  null
  
)

export default component.exports